import type { LocalInterviewPort } from '@Domain/Ports/LocalInterviews/LocalInterviewPort';
import PortsContext from '@UI/Providers/PortsProvider/PortsContext';
import * as React from 'react';

function useLocalInterviewPort(): LocalInterviewPort {
	const context = React.useContext(PortsContext);

	if (context === null) {
		throw new Error('useLocalInterviewPort doit être utilisé à l’intérieur d’un PortsProvider.');
	}

	return context.localInterviews;
}

export default useLocalInterviewPort;
